import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { FaHome } from "react-icons/fa"; // İKON EKLENDİ
import styles from "./styles.module.css";

const apiUrl = process.env.REACT_APP_API_BASE_URL;


const Signup = () => {
    const [data, setData] = useState({
        username: "", // username olması gerekiyor
        email: "",
        password: "",
    });

    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleChange = ({ currentTarget: input }) => {
        setData({ ...data, [input.name]: input.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const url = `${apiUrl}/api/users/register`; // Doğru endpoint
            await axios.post(url, data);
            navigate("/login"); // Kayıt sonrası giriş sayfasına yönlendir
        } catch (error) {
            if (error.response && error.response.status >= 400 && error.response.status <= 500) {
                setError(error.response.data.error); // Backend error mesajını göster
            }
        }
    };

    return (
        <div className={styles.signup_container}>
             <Link to="/" className={styles.back_home_link}>
                            <button className={styles.back_home_btn}>
                                <FaHome style={{ marginRight: "8px" }} />
                                Siteye Dön
                            </button>
                        </Link>
            <div className={styles.signup_form_container}>
                <div className={styles.left}>
                    <h1>Hoşgeldiniz</h1>
                    <Link to="/login">
                        <button type="button" className={styles.white_btn}>
                            Giriş Yap
                        </button>
                    </Link>
                </div>
                <div className={styles.right}>
                    <form className={styles.form_container} onSubmit={handleSubmit}>
                        <h1>Hesap Oluştur</h1>
                        <input
                            type="text"
                            placeholder="Kullanıcı Adı"
                            name="username"
                            onChange={handleChange}
                            value={data.username}
                            required
                            className={styles.input}
                        />
                        <input
                            type="email"
                            placeholder="Email"
                            name="email"
                            onChange={handleChange}
                            value={data.email}
                            required
                            className={styles.input}
                        />
                        <input
                            type="password"
                            placeholder="Şifre"
                            name="password"
                            onChange={handleChange}
                            value={data.password}
                            required
                            className={styles.input}
                        />
                        {error && <div className={styles.error_msg}>{error}</div>}
                        <button type="submit" className={styles.green_btn}>
                            Kayıt Ol
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Signup;
